<h1 mat-dialog-title>{{ 'scheduler.setup.api.title' | translate }}</h1>

<mat-dialog-content>

  <iframe [src]="frameUrl | safe" class="api-docs"></iframe>

</mat-dialog-content>
<mat-dialog-actions>
  <span class="spacer"></span>
  <a [href]="frameUrl" color="primary" mat-raised-button target="_blank">Open in new tab</a>

  <button color="primary" mat-dialog-close mat-flat-button type="reset">Close</button>
</mat-dialog-actions>